module.exports = __webpack_public_path__ + "307ba3a8b8b2ed609242aeed19d1c710.png";